module.exports = __webpack_public_path__ + "static/media/virgen-coromoto-corona.c960b37e.jpg";